import StateConstants from "src/states/StateContstants";
import RedirectToLoginException from "src/validation/exception_messages/RedirectToLoginException";

function UserVisibleErrorStoringDecorator(loadingStateKey: string = StateConstants.IS_LOADING): MethodDecorator {
    return (target, propertyKey, descriptor: any) => {
        const originalMethod = descriptor.value;

        descriptor.value = async function (...args: any[]) {
            this.stateHandler.set(loadingStateKey, true);
            
            if (!this.stateHandler) {
                throw new Error("This class must have a stateHandler in order to use the UserErrorDecorator");
            }
            
            try {
                return await originalMethod.apply(this, args);
            } catch (error: any) {
                if (error instanceof RedirectToLoginException) {
                    return;
                }

                this.stateHandler.set("error", error);
                this.stateHandler.set(loadingStateKey, false);
                
                if (!this.stateHandler.get(StateConstants.STATE_UPDATE_COUNT)) {
                    this.stateHandler.set(StateConstants.STATE_UPDATE_COUNT, 0);
                }
                this.stateHandler.set(StateConstants.STATE_UPDATE_COUNT, this.stateHandler.get(StateConstants.STATE_UPDATE_COUNT) + 1);
            } finally {
                this.stateHandler.set(loadingStateKey, false);
            }
        };
        return descriptor;
    };
}

export default UserVisibleErrorStoringDecorator